import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GitStatus, GitStatusService } from 'src/core/services';
import { environment } from 'src/main/environments';

@Component({
  selector: 'core-environment-information',
  templateUrl: './environment-information.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class EnvironmentInformationComponent {
  private gitStatusService = inject(GitStatusService);

  environment = environment;
  backgroundColor = this.getBackgroundColor();
  textColor = this.getTextColor();
  gitStatus$: Observable<GitStatus>;

  constructor() {
    this.gitStatus$ = this.gitStatusService.getGitStatus$();
  }

  getBackgroundColor() {
    switch (environment.name) {
      case 'staging':
        return 'bg-red-400';
      case 'testing':
        return 'bg-yellow-200';
      default:
        return 'bg-blue-100';
    }
  }

  getTextColor() {
    return environment.name === 'staging' ? 'text-white' : 'text-black';
  }
}
